"use strict";

exports.__esModule = true;
exports.MissingWidgetThumbnail = MissingWidgetThumbnail;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * A thumbnail for missing widgets.
 */
function MissingWidgetThumbnail(props) {
  var type = props.type,
    _props$x = props.x,
    x = _props$x === void 0 ? 0 : _props$x,
    _props$y = props.y,
    y = _props$y === void 0 ? 0 : _props$y,
    width = props.width,
    height = props.height,
    render = props.render,
    _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? "rgba(0, 0, 0, 0.05)" : _props$backgroundColo,
    children = props.children;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    x: x,
    y: y,
    width: width,
    height: height,
    "data-component": type
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: 0,
    y: 0,
    width: width,
    height: height,
    fill: backgroundColor
  }), render(children));
}